// extracted by mini-css-extract-plugin
module.exports = {"policyContainer":"styles_policyContainer__3Hpew","underlineText":"styles_underlineText__k2yED"};